/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-else-return */
/* eslint-disable no-void */
import React, { useEffect, useRef, useState } from "react";
import { IconButton, type IconButtonProps } from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { FiChevronDown, FiChevronUp, FiX } from "react-icons/fi";
import { Loading } from "../Loading";
import * as Styles from "./select.styles";

interface Props extends IconButtonProps {
  onChange: any;
  data: any[];
  limitResult?: number;
  value: any;
  isError?: boolean;
  clearIcon?: boolean;
  helperText?: string;
  placeholder?: any;
  isMultitple?: boolean;
  marginRightProps?: number;
  iconButton?: any;
  href?: any;
  disabled?: boolean;
  isLoading?: boolean;
  selectedObj?: (val: any) => void;
  border?: string;
  multiple?: boolean;
  renderLabel?: boolean;
}

export const SelectComponent: React.FC<Props> = (props: Props, ...rest) => {
  const [open, setOpen] = React.useState(false);
  const parentRef = useRef<HTMLDivElement | null>(null);
  const [childWidth, setChildWidth] = useState(1);

  useEffect(() => {
    void onHandleChange();
  }, [props.value, props?.data]);

  const onHandleChange = async () => {
    const selectedOption = await props?.data?.find(
      (option) => option?.value === props.value
    );

    if (props.selectedObj && selectedOption) {
      props.selectedObj(selectedOption);
    }
  };

  // arruma a largura do select expandir além
  // do container no caso de ser multiple
  useEffect(() => {
    const handleResize = () => {
      if (parentRef.current) {
        const parentWidth = parentRef.current.offsetWidth;
        let _childWidth = parentWidth * (props.clearIcon ? 0.5 : 0.65);
        if (parentWidth < 200)
          _childWidth = parentWidth * (props.clearIcon ? 0.35 : 0.55);
        setChildWidth(_childWidth);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Styles.Container isError={props.isError} ref={parentRef}>
      <Styles.Row>
        {props.iconButton !== null ? (
          <IconButton href={props.href} target="_blank" size="small" {...rest}>
            {props.iconButton}
          </IconButton>
        ) : null}
      </Styles.Row>
      <Select
        displayEmpty
        renderValue={(selected) => {
          if (props.multiple) {
            if (selected === "" || selected.length === 0) {
              return (
                <p
                  style={{
                    color: "#666",
                    opacity: 0.65,
                    maxWidth: `${childWidth}px`,
                  }}
                >
                  {props?.placeholder ?? "Selecione as opções"}
                </p>
              );
            } else if (props.renderLabel) {
              return (
                <p
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: `${childWidth}px`,
                  }}
                >
                  {selected
                    .map(
                      (value: string) =>
                        props.data?.find((item) => item.value === value)?.label
                    )
                    .join(", ")}
                </p>
              );
            } else {
              return (
                <p
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: `${childWidth}px`,
                  }}
                >
                  {selected.join(", ")}
                </p>
              );
            }
          } else if (selected === "") {
            return (
              <p
                style={{
                  color: "#666",
                  opacity: 0.65,
                }}
              >
                {props?.placeholder ?? "Selecione"}
              </p>
            );
          } else if (props.renderLabel) {
            return (
              <p
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: `${childWidth}px`,
                }}
              >
                {props.data?.find((item) => item.value === selected)?.label}
              </p>
            );
          } else {
            return selected;
          }
        }}
        style={{
          borderRadius: props.border ?? 8,
          fontFamily: "Inter",
          fontWeight: 500,
          fontSize: 14,
        }}
        multiple={props?.multiple}
        endAdornment={
          open ? (
            <FiChevronUp
              size={22}
              color="#666"
              onClick={() => {
                !props.disabled && setOpen(false);
              }}
            />
          ) : props.isLoading ? (
            <div>
              <Loading size={14} />
            </div>
          ) : (
            <FiChevronDown
              size={22}
              color="#666"
              onClick={() => {
                !props.disabled && setOpen(true);
              }}
            />
          )
        }
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        open={open}
        IconComponent={() =>
          (props.multiple
            ? props.value?.length > 0
            : typeof props?.value === "boolean" || props?.value) &&
          props.clearIcon ? (
            <IconButton
              onClick={() => {
                props.onChange(props?.multiple ? [] : "");
              }}
            >
              <FiX size={20} style={{ marginRight: 8 }} color="#666" />
            </IconButton>
          ) : null
        }
        value={props.value ?? ""}
        onChange={(event) => {
          !props?.disabled &&
            props.onChange(event?.target?.value as string | number);
        }}
        defaultValue=""
        size="small"
        disabled={props.disabled}
        sx={{
          backgroundColor: props.disabled ? "rgba(0,0,0,0.08)" : "#ffffff",
          "&:hover": {
            cursor: props.disabled ? "not-allowed" : "pointer",
          },
          "::selection": {
            color: "#333",
          },
          minHeight: "44px",
          "& .MuiSelect-select": {
            paddingRight: "0px !important",
          },
        }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 48 * 4.5 + 8,
              width: "fit-content",
            },
          },
        }}
      >
        {props?.data &&
          props.data?.map((item: any) => (
            <MenuItem
              key={item.value}
              value={item.value}
              disabled={item?.disabled}
            >
              {item.label}
            </MenuItem>
          ))}
      </Select>
    </Styles.Container>
  );
};

SelectComponent.defaultProps = {
  iconButton: null,
  disabled: false,
};
